import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'objectNameOrAdvertisementDescLabel',
  standalone: true
})
export class ObjectNameOrAdvertisementDescLabelPipe implements PipeTransform {

  transform(value: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case value?.applicationSubject === 'Lokalizacji obiektu budowlanego': {
        return 'Opis obiektu budowlanego';
      }
      case value?.applicationSubject === 'Lokalizacji reklamy': {
        return 'Opis reklamy';
      }
      case value?.applicationSubject === 'Lokalizacja reklamy posadowionej na obiekcie budowlanym': {
        return 'Opis reklamy posadowionej na obiekcie budowlanym';
      }
      default: {
        return 'Opis obiektu/reklamy';
      }
    }
  }

}
